export default class DetailsColumnField {
  constructor({ fieldLabel, fieldName }) {
    this.fieldLabel = fieldLabel;
    this.fieldName = fieldName;
  }
}
